// extracted by mini-css-extract-plugin
export default {"divider":"divider-18ef7","shine":"shine-18ef7"};